import { render, staticRenderFns } from "./AddToWatchlist.vue?vue&type=template&id=43426bd5&scoped=true&"
import script from "./AddToWatchlist.vue?vue&type=script&lang=js&"
export * from "./AddToWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43426bd5",
  null
  
)

export default component.exports